
import React from 'react';

import { CardKinds } from '../redux/cardTemplateDbSlice';
import CommonCardTemplatePreview from './CommonCardTemplatePreview';
import UiCardPreview from './UiCardPreview';
import MemoCardPreview from './MemoCardPreview';
import DrawCardPreview from '../card_components/DrawCardPreview';

type ComponentHashType = {
  [key in CardKinds]: React.FC<any>;
}

// コンポーネント名 → コンポーネント表示
const componentHash: ComponentHashType = {
  'common': CommonCardTemplatePreview,
  'ui': UiCardPreview,
  'memo': MemoCardPreview,
  'draw': DrawCardPreview
};

// -----

export const getCardTemplate = (kind: CardKinds, id?: string, selected?: boolean): React.FunctionComponentElement<any> => {
  if (kind !== 'common') return React.createElement(componentHash[kind], { selected });
  else return React.createElement(componentHash[kind], { cardTemplateId: id, selected });
}
